import styled from "styled-components";
import { IconButton } from "@material-ui/core";

export const StyledIconButton = styled(IconButton)`
    position: absolute;
    right: 20px;
    top: 20px;
`;
